export default __webpack_public_path__ + "static/media/esrp4.a816ad46.svg";